/* eslint-disable no-console */
import React, { useEffect } from 'react'
import { ContentComponentType } from '@splunk-iteng/splunk-shared-components/dist/lib/Types/ContentComponentType'
import { useDplScreenQuery } from '../../graphql/graphql'

export function DplResultsComponent({
  currentState,
  doSubmit
}: ContentComponentType) {
  const { email = null } = currentState
  const {
    data = {},
    loading,
    error
  } = useDplScreenQuery({
    variables: { email },
    skip: !doSubmit || !email
  })

  useEffect(() => {
    if (error) {
      if (error.message.includes('Must be in email format')) {
        alert('Please provide a valid email')
      } else {
        alert(error.message)
      }
    }
  }, [error])

  if (!email) {
    return (
      <div className="p-20">Please enter an email to check in DPL table.</div>
    )
  }
  if (loading) {
    return <div className="p-20">Checking user in DPL table...</div>
  }

  if (error) {
    return <div className="p-20">There was an error during the check</div>
  }

  const { dplScreen } = data

  if (!dplScreen) {
    return <div> </div>
  }

  const {
    email: mail,
    firstName,
    lastName,
    company,
    country,
    created
  } = dplScreen

  const found = mail !== ''

  const date = found && new Date(created)

  const pacificTime =
    found &&
    new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Los_Angeles',
      dateStyle: 'full',
      timeStyle: 'long'
    }).format(date)

  return (
    <div>
      {found ? (
        <div className="pt-20">
          <h1 className="text-2xl font-bold">Denied Person Details</h1>
          <h3>First name: {firstName}</h3>
          <h3>Last name: {lastName}</h3>
          <h3>Email: {mail}</h3>
          <h3>Company: {company}</h3>
          <h3>Country: {country}</h3>
          <h3>Flagged: {pacificTime}</h3>
        </div>
      ) : (
        <div className="row">
          <div className="col-12">User {mail} is not in the DPL table.</div>
        </div>
      )}
    </div>
  )
}
